import { render, staticRenderFns } from "./GradesDesktop.vue?vue&type=template&id=56f73350&"
import script from "./GradesDesktop.vue?vue&type=script&lang=js&"
export * from "./GradesDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports